import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './main.css'
// import './lib/firebase'

// A tab left open across a deploy still references the *old* build's hashed
// chunk filenames (route components, lazy-loaded features like the PDF
// export) — those files no longer exist once a newer deploy replaces them,
// so any dynamic import() for one 404s with "Failed to fetch dynamically
// imported module." Vite fires this event for every such failure; reloading
// once re-fetches the current index.html (and therefore the current chunk
// hashes), which self-heals it instead of leaving staff stuck on a dead
// button. Guarded to once per tab session so a genuine network outage
// doesn't reload-loop forever.
window.addEventListener('vite:preloadError', () => {
  const key = 'vite-preload-reloaded'
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1')
    window.location.reload()
  }
})

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')
